import React from "react";
import {
  Dialog,
  Grid,
  Typography,
  IconButton,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { Clear } from "@material-ui/icons";

export default function DefaultsDialog(props) {
  const {
    openDialog,
    closeDialog,
    classes,
    changeValueFn,
    title,
    CustomComponent,
    activeKey,
  } = props;
  const [isLoading, setLoading] = React.useState(false);
  return (
    <Dialog
      open={openDialog}
      maxWidth="xs"
      onClose={closeDialog}
      aria-labelledby="form-dialog-title"
      className={classes.plandialogContainer}
    >
      <Grid
        item
        container
        justifyContent="flex-end"
        xs={12}
        style={{
          height: 30,
          marginBottom: 10,
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: 16,
          paddingRight: 8,
        }}
      >
        <Typography variant="h4">{title}</Typography>
        <IconButton onClick={closeDialog}>
          <Clear />
        </IconButton>
      </Grid>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid
            container
            style={{
              alignItems: "center",
              paddingRight: "8px",
              marginTop: "15px",
              justifyContent: "space-between",
            }}
          >
            <Grid item xs={12} style={{ marginBottom: "20px" }}>
              <CustomComponent />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid
          item
          container
          xs={12}
          style={{
            alignItems: "flex-end",
            justifyContent: "end",
            paddingRight: "15px",
            marginBottom: "8px",
          }}
        >
          <Button
            // color="primary"
            variant="outlined"
            onClick={closeDialog}
            style={{ marginRight: 8 }}
          >
            Cancel
          </Button>
          {/* // assistant.wabaProgressStep === 9 && assistant.familyId */}
          <Button
            color="primary"
            variant="contained"
            onClick={async () => {
              setLoading(true);
              await changeValueFn(activeKey);
              setLoading(false);
            }}
            disabled={isLoading}
            endIcon={isLoading ? <CircularProgress size={20} /> : ""}
          >
            Update
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
